import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "p-fluid formgrid grid" }
const _hoisted_2 = { class: "field col-12 lg:col-4" }
const _hoisted_3 = { class: "field col-12 lg:col-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "field col-12 lg:col-3" }, null, -1)
const _hoisted_5 = { class: "field col-12 lg:col-2 text-right" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { style: {"display":"block"} }, " ", -1)
const _hoisted_7 = {
  key: 0,
  class: "col-12"
}
const _hoisted_8 = {
  key: 1,
  class: "field col-12 text-right"
}
const _hoisted_9 = {
  key: 2,
  class: "col-12"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.handleSubmit()), ["prevent"])),
    onKeydown: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleKeydown($event)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", null, _toDisplayString(_ctx.t("branch.branch")), 1),
        _createVNode(_component_Dropdown, {
          filter: true,
          options: _ctx.branches,
          optionLabel: "name",
          optionValue: "id",
          placeholder: "-",
          modelValue: _ctx.branchId,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.branchId) = $event)),
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dataChanged()))
        }, null, 8, ["options", "modelValue"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", null, _toDisplayString(_ctx.t("statBranchMonthReport.month")), 1),
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.monthDate,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.monthDate) = $event)),
          options: _ctx.months,
          onChange: _ctx.dataChanged,
          optionLabel: "label",
          optionValue: "date",
          placeholder: "-"
        }, null, 8, ["modelValue", "options", "onChange"])
      ]),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_Button, {
          label: _ctx.t('buttons.search'),
          icon: "pi pi-search",
          type: "submit",
          class: "p-button-primary p-uppercase"
        }, null, 8, ["label"])
      ]),
      (_ctx.showResults)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_Divider)
          ]))
        : _createCommentVNode("", true),
      (_ctx.showResults && _ctx.results.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_Button, {
              label: _ctx.t('buttons.print'),
              icon: "pi pi-print",
              class: "p-button-primary p-uppercase",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.printPaper()))
            }, null, 8, ["label"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showResults)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_DataTable, {
              dataKey: "employee.id",
              responsiveLayout: "scroll",
              showGridlines: "",
              sortField: "employee.fullName",
              sortOrder: 1,
              stripedRows: "",
              value: _ctx.results
            }, {
              empty: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("gen.noData")), 1)
              ]),
              loading: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("gen.loading")), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "employee",
                  header: _ctx.t('employee.employee'),
                  headerStyle: "width: 60%"
                }, {
                  body: _withCtx(({ data, field }) => [
                    _createTextVNode(_toDisplayString(data[field]?.fullName ?? "-"), 1)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "counters",
                  header: _ctx.t('statBranchMonthReport.counters.totalHours'),
                  bodyClass: "text-right",
                  footerClass: "text-right",
                  headerStyle: "width: 20%"
                }, {
                  body: _withCtx(({ data, field }) => [
                    _createTextVNode(_toDisplayString(_ctx.n(data[field].totalHours, "number1")), 1)
                  ]),
                  footer: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_ctx.n(_ctx.branchCounters.totalHours, "number1")), 1)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "counters",
                  header: _ctx.t('statBranchMonthReport.counters.overtimeHours'),
                  bodyClass: "text-right",
                  footerClass: "text-right",
                  headerStyle: "width: 20%"
                }, {
                  body: _withCtx(({ data, field }) => [
                    _createTextVNode(_toDisplayString(_ctx.n(data[field].overtimeHours, "number1")), 1)
                  ]),
                  footer: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_ctx.n(_ctx.branchCounters.overtimeHours, "number1")), 1)
                  ]),
                  _: 1
                }, 8, ["header"])
              ]),
              _: 1
            }, 8, ["value"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 32))
}